import React from "react";
import { CourseFinanceForm } from "../../CourseFinances/CourseFinanceForm/CourseFinanceForm";
import { CreateCourseFinanseRequest } from "api/course-finances/courseFinancesApi";
import { PaziaModal } from "components/molecules";
import { ModalPadding } from "components/templates/Modals/ModalPadding";
import { useCourseFinanceCategoryOptions } from "api/course-finances";

interface CreateCourseFinanceModalProps {
  onCloseRequest: () => void;
  isOpen: boolean;
  courseId: number;
  onSubmit: (data: CreateCourseFinanseRequest) => Promise<void>;
}

export const CreateCourseFinanceModal = ({
  onCloseRequest,
  isOpen,
  courseId,
  onSubmit,
}: CreateCourseFinanceModalProps) => {
  const { loading, options } = useCourseFinanceCategoryOptions(false);

  if (loading || !options) return null;

  return (
    <PaziaModal id="craete-topic-modal" onCloseRequest={onCloseRequest} isOpen={isOpen} size="xl">
      <ModalPadding>
        <div className="text-xl">
          <div className="mb-2 font-medium text-slate-800 dark:text-slate-100">Tworzenie nowej płatności</div>
        </div>

        <CourseFinanceForm onSubmit={onSubmit} categories={options} courseId={courseId} onCancel={onCloseRequest} />
      </ModalPadding>
    </PaziaModal>
  );
};
